export var IAchLinkingOfferEligibilityResponse;
(function (IAchLinkingOfferEligibilityResponse) {
    /**
     * for the current retailer session, show the eligibility for an ACH linking offer
     */
    let AchOfferSurface;
    (function (AchOfferSurface) {
        AchOfferSurface["ACH_OFFER_SURFACE_UNKNOWN"] = "ACH_OFFER_SURFACE_UNKNOWN";
        AchOfferSurface["ACCOUNT_DROPDOWN"] = "ACCOUNT_DROPDOWN";
        AchOfferSurface["CHECKOUT"] = "CHECKOUT";
        AchOfferSurface["PROMO_MODAL"] = "PROMO_MODAL";
    })(AchOfferSurface = IAchLinkingOfferEligibilityResponse.AchOfferSurface || (IAchLinkingOfferEligibilityResponse.AchOfferSurface = {}));
    /**
     * Return an instance of IAchLinkingOfferEligibilityResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IAchLinkingOfferEligibilityResponse.build = (partial) => (Object.assign({ claimed_offers: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IAchLinkingOfferEligibilityResponse || (IAchLinkingOfferEligibilityResponse = {}));
